/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260430
*/

'use strict';

import { getMembersDataAsync } from './snMembers.js';
import { appDebugMode, baseURL, getAppToken } from './snSite.js';

const showReportAsync = async (params = {}) => {

    const data = await getMembersDataAsync()
    const memberContacts = data.map(m => ({
            name: m.name,
            email: m.email,
            phone: m.phone
        }));

    $("#reportViewer1")
        .telerik_ReportViewer({
            serviceUrl: `${baseURL}/api/reports`,
            templateUrl: `${baseURL}/api/ReportViewer/Template`,
            reportSource: {
                report: 'RptChurchDirectory.trdp',
                parameters: { churchMembers: JSON.stringify(memberContacts) }
            },
            viewMode: telerikReportViewer.ViewModes.INTERACTIVE,
            scaleMode: telerikReportViewer.ScaleModes.SPECIFIC,
            scale: 1.0,
            enableAccessibility: false,
            sendEmail: { enabled: false }
        });

}

window.snRptChurchDirectory = {
    showReportAsync
}